import type { ReactElement, PropsWithChildren } from 'react';
import React, { useContext, createContext, useState } from 'react';

import type { MessageType } from '../interfaces';

interface INotificationData {
  isOpen?: boolean;
  message?: ReactElement | string;
  messageId?: string;
  type?: keyof typeof MessageType;
  customIcon?: ReactElement;
}

export const NotificationContext = createContext<{
  notificationData: {
    data?: INotificationData;
    setNotificationData: (data: INotificationData) => void;
  };
}>({
  notificationData: {
    setNotificationData: () => {},
  },
});

export const NotificationProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [data, setNotificationData] = useState<INotificationData>({});

  return (
    <NotificationContext.Provider
      value={{
        notificationData: { data, setNotificationData },
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotificationData = () => {
  const ctx = useContext(NotificationContext);

  return {
    context: ctx,
  };
};
